import React, {FC, ReactElement} from 'react';
import {GUTTER} from "../../../constants";
import {Col, Row, Space} from "antd";
import {AverageScoreCard} from "../components/Generic/AverageScoreCard";
import {AverageTimeSpentCard} from "../components/Generic/AverageTimeSpentCard";

export const ConversationElicitTab: FC = (): ReactElement => {
    return (
        <Row gutter={GUTTER}>
            <Col xl={6} xs={24}>
                <Space direction='vertical' size='middle' style={{width: '100%'}}>
                    <AverageScoreCard/>
                    <AverageTimeSpentCard/>
                </Space>
            </Col>
        </Row>
    );
};